import { render, staticRenderFns } from "./sysMsg.vue?vue&type=template&id=b182a810&scoped=true"
import script from "./sysMsg.vue?vue&type=script&lang=js"
export * from "./sysMsg.vue?vue&type=script&lang=js"
import style0 from "./sysMsg.vue?vue&type=style&index=0&id=b182a810&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b182a810",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b182a810')) {
      api.createRecord('b182a810', component.options)
    } else {
      api.reload('b182a810', component.options)
    }
    module.hot.accept("./sysMsg.vue?vue&type=template&id=b182a810&scoped=true", function () {
      api.rerender('b182a810', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/msg/sysMsg.vue"
export default component.exports